import {Component, inject} from '@angular/core'
import {MatIconButton, MatMiniFabButton} from '@angular/material/button'
import {MatDialog} from '@angular/material/dialog'
import {MatIcon, MatIconRegistry} from '@angular/material/icon'
import {MatTooltip} from '@angular/material/tooltip'
import {DomSanitizer} from '@angular/platform-browser'
import {RouterLink} from '@angular/router'
import {HOME_PATH} from '../../general/shared'
import {ProjectService} from '../../services/project.service'
import {UserService} from '../../services/user-service'
import {Menu} from '../menu/menu'

@Component({
  selector: 'smt-header',
  imports: [
    MatIcon,
    MatMiniFabButton,
    MatIconButton,
    RouterLink,
    MatTooltip
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {

  private readonly dialog = inject(MatDialog)
  private readonly userService = inject(UserService)
  private readonly projectService = inject(ProjectService)
  private readonly iconRegistry = inject(MatIconRegistry)
  private readonly sanitizer = inject(DomSanitizer)

  protected readonly HOME_PATH = HOME_PATH

  constructor() {
    this.iconRegistry.addSvgIcon('icon', this.sanitizer.bypassSecurityTrustResourceUrl('icon.svg'))
  }

  public openMenu() {
    this.dialog.open(Menu, {
      maxWidth: '330px'
    })
  }

  public toggleAdmin() {
    const isAdmin = this.userService.user().scopes
      .includes('admin')
    this.userService.user.update(user => (
      {
        ...user,
        scopes: isAdmin ? [''] : ['admin']
      }
    ))
  }

  public toggleFirstTime() {
    this.userService.user.update(user => ({
      ...user,
      firstTimeLogin: !user.firstTimeLogin
    }))
  }

  public removeAllProjects() {
    this.projectService.projects.set([])
  }
}
